/* import __COLOCATED_TEMPLATE__ from './procedure-info-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Signature {
  Args: {
    suggestionType: string;
    onOpenSection?: (sectionId: string) => void;
  };
}

export default class ProcedureInfoItem extends Component<Signature> {
  @service declare router: RouterService;
  @service declare appService: AppService;

  @action
  createTask() {
    let appId = this.appService.app.id;
    let url = this.router.urlFor('apps.app.automation.fin-ai-agent.tasks', appId);
    safeWindowOpen(url, '_blank');
  }

  @action
  learnMore() {
    safeWindowOpen(
      'https://www.intercom.com/help/en/articles/12495167-fin-procedures-explained',
      '_blank',
    );
  }

  @action
  openCustomerQueries() {
    this.args.onOpenSection?.('2');
  }

  @action
  setupClickHandlers(element: HTMLElement) {
    element.addEventListener('click', (event) => {
      let target = event.target as HTMLElement;
      if (target.dataset.action === 'openCustomerQueries') {
        event.preventDefault();
        this.openCustomerQueries();
      }
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::ProcedureInfoItem': typeof ProcedureInfoItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/procedure-info-item': typeof ProcedureInfoItem;
  }
}
